<div class="get-sensitive-data-input-action">
    <div class="sensitive-data-wait-value-container" *ngIf="(isSensitiveBlockVisible$ | async) === false">
        <div class="sensitive-data-wait-value" [ngStyle]="{ width: showPopupBtn ? 'calc(100% - 105px)' : '100%' }">
            <div class="sensitive-content-icon"><img src="assets/images/common/sensitive-content.svg" /></div>
            <div class="text">{{ "sensitiveDataInput.description" | labelsProvider }}</div>
        </div>
        <div *ngIf="showPopupBtn">
            <button class="sensitive-button" (click)="getSensitiveData($event)">
                {{ "sensitiveDataInput.btnText" | labelsProvider }}
            </button>
        </div>
    </div>

    <div class="sensitive-data-field-value-container" *ngIf="isSensitiveBlockVisible$ | async">
        <ng-container *ngIf="(isSpinnerVisible$ | async) === false; else showSpinner">
            <div class="top-controls">
                <mat-slide-toggle
                    *ngIf="showRawDataSwitch"
                    class="raw-sensitive-data-input-toggle"
                    [(ngModel)]="rawSensitiveDataMode"
                    labelPosition="before">
                    {{ showRawDataLabel }}
                </mat-slide-toggle>
                <app-copy-button
                    class="sensitive-data-field-copy-button"
                    [successPopupPosition]="popUpPosition"
                    [value]="useInnerHtml && !rawSensitiveDataMode ? (sensitiveData | stripHtml) : sensitiveData"></app-copy-button>
            </div>
            @if (!useInnerHtml || rawSensitiveDataMode) {
                <div class="sensitive-data-field-value">
                    @for (indexPoisiton of sortedSensitivePositions; track indexPoisiton) {
                        @if ($first){{{sensitiveData.substring(0, indexPoisiton)}}} 
                        @else {{{ sensitiveData.substring(sortedSensitivePositions[$index-1], indexPoisiton) }}}
                        <img class="icon-field-sensitive"
                            src="assets/images/status-icons/attention.svg"
                            height="16"
                            [matTooltip]="sensitiveIconToolTipLabelPath | labelsProvider" />
                        @if ($last) {{{ sensitiveData.substring(indexPoisiton) }}}
                    }
                    @if (sortedSensitivePositions.length === 0) {{{ sensitiveData }}}
                </div>
            }
            <div class="sensitive-data-field-value" *ngIf="useInnerHtml && !rawSensitiveDataMode" [innerHtml]="sensitiveData | stripHtml"></div>
        </ng-container>

        <ng-template #showSpinner>
            <div class="sensitive-data-block-spinner">
                <mat-progress-spinner [diameter]="42" class="spinner" mode="indeterminate" />
            </div>
        </ng-template>
    </div>
</div>
